/**
 * PLANS DE SOUDURE™ — purchase configuration.
 *
 * CHECKOUT_URL is the single destination used by every purchase button
 * (offer CTA, final CTA and mobile sticky bar).
 *
 * If it is ever emptied, all purchase buttons fall back to a disabled state so
 * no visitor is sent to a wrong or missing checkout.
 */
export const CHECKOUT_URL = 'https://plans-de-soudure.impultienda.ar/checkout'

export const PRICE = {
  value: 39,
  currency: 'USD',
  label: '39 $ US',
  original: '79 $ US',
  perProject: '1,30 $ US',
  note: 'Paiement unique. Collection numérique en PDF.',
} as const
